import "./bootstrap";
import "@mantine/core/styles.css";
import '@mantine/spotlight/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import 'mantine-react-table/styles.css';
import "../css/app.css";

import { createRoot } from "react-dom/client";
import {
  ColorSchemeScript,
  MantineProvider
} from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ModalsProvider } from "@mantine/modals";
import CustomSpotlightProvider from "@/Components/CustomSpotlightProvider";
import * as Sentry from "@sentry/react";
import React from "react";
import ErrorPage from "@/Components/ErrorPage";
import {myTheme} from "@/theme";
import { DatesProvider } from '@mantine/dates';
import dayjs from 'dayjs';
import "dayjs/locale/hu";
import utc from 'dayjs/plugin/utc'; // Import UTC plugin
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.locale('hu');
dayjs.tz.setDefault("Europe/Budapest");

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  replaysOnErrorSampleRate: 0.9,
  replaysSessionSampleRate: 0.1
});

const appName = window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.tsx`,
      import.meta.glob("./Pages/**/*.tsx")
    ),
  setup({ el, App, props }) {
    const root = createRoot(el);
    root.render(
      <Sentry.ErrorBoundary fallback={ErrorPage} showDialog>
        <ColorSchemeScript forceColorScheme="light" />
        <MantineProvider theme={myTheme} forceColorScheme="light">
          <DatesProvider
            settings={{
              locale: "hu",
              firstDayOfWeek: 1,
              consistentWeeks: true
            }}
          >
          <CustomSpotlightProvider>
            <ModalsProvider>
              <Notifications position="bottom-center" />
              <App {...props} />
            </ModalsProvider>
          </CustomSpotlightProvider>
          </DatesProvider>
        </MantineProvider>
      </Sentry.ErrorBoundary>
    );
  },
  progress: {
    color: "#1B1464",
  },
});
